import { FeatureFlag } from 'models/Config';
import useAppConfig from './useAppConfig';

export interface AllowedFlags {
  allowAutomationV3: boolean;
  allowPropertiesWebapp: boolean;
  allowPropertyEditV3Beta: boolean;
  allowOrderViewWebapp: boolean;
  allowChannelsV3: boolean;
  allowIntegrationsV3: boolean;
}

const useFeatures = (): AllowedFlags => {
  const { featureFlags } = useAppConfig();

  return {
    allowAutomationV3: featureFlags.includes(FeatureFlag.ALLOW_AUTOMATION_V3),
    allowPropertiesWebapp: !featureFlags.includes(
      FeatureFlag.ALLOW_PROPERTIES_WEBAPP,
    ),
    allowPropertyEditV3Beta: !featureFlags.includes(
      FeatureFlag.ALLOW_PROPERTY_EDIT_V3_BETA,
    ),
    allowOrderViewWebapp: !featureFlags.includes(
      FeatureFlag.ALLOW_ORDER_VIEW_WEBAPP,
    ),
    allowChannelsV3: !featureFlags.includes(FeatureFlag.ALLOW_CHANNELS_V3),
    allowIntegrationsV3: !featureFlags.includes(
      FeatureFlag.ALLOW_INTEGRATIONS_V3,
    ),
  };
};

export default useFeatures;
